const AUTHTOKEN_LOGOUT = "AUTHTOKEN_LOGOUT";
const SERVICES_REQUEST = "SERVICES_REQUEST";
const SERVICES_ERROR = "SERVICES_ERROR";
const SERVICES_SUCCESS = "SERVICES_SUCCESS";
const SERVICE_REQUEST = "SERVICE_REQUEST";
const SERVICE_ERROR = "SERVICE_ERROR";
const SERVICE_SUCCESS = "SERVICE_SUCCESS";
const SERVICE_MACTABLE_REQUEST = "SERVICE_MACTABLE_REQUEST";
const SERVICE_MACTABLE_ERROR = "SERVICE_MACTABLE_ERROR";
const SERVICE_MACTABLE_SUCCESS = "SERVICE_MACTABLE_SUCCESS";
const SERVICE_L1_REQUEST = "SERVICE_L1_REQUEST";
const SERVICE_L1_ERROR = "SERVICE_L1_ERROR";
const SERVICE_L1_SUCCESS = "SERVICE_L1_SUCCESS";
const SERVICE_LIGHT_REQUEST = "SERVICE_LIGHT_REQUEST";
const SERVICE_LIGHT_ERROR = "SERVICE_LIGHT_ERROR";
const SERVICE_LIGHT_SUCCESS = "SERVICE_LIGHT_SUCCESS";
const SERVICE_UTILISATION_REQUEST = "SERVICE_UTILISATION_REQUEST";
const SERVICE_UTILISATION_ERROR = "SERVICE_UTILISATION_ERROR";
const SERVICE_UTILISATION_SUCCESS = "SERVICE_UTILISATION_SUCCESS";
const SERVICE_TRAFFIC_REQUEST = "SERVICE_TRAFFIC_REQUEST";
const SERVICE_TRAFFIC_ERROR = "SERVICE_TRAFFIC_ERROR";
const SERVICE_TRAFFIC_SUCCESS = "SERVICE_TRAFFIC_SUCCESS";
const SERVICE_LIGHTHISTORY_REQUEST = "SERVICE_LIGHTHISTORY_REQUEST";
const SERVICE_LIGHTHISTORY_ERROR = "SERVICE_LIGHTHISTORY_ERROR";
const SERVICE_LIGHTHISTORY_SUCCESS = "SERVICE_LIGHTHISTORY_SUCCESS";
const SERVICE_TRAFFICHISTORY_REQUEST = "SERVICE_TRAFFICHISTORY_REQUEST";
const SERVICE_TRAFFICHISTORY_ERROR = "SERVICE_TRAFFICHISTORY_ERROR";
const SERVICE_TRAFFICHISTORY_SUCCESS = "SERVICE_TRAFFICHISTORY_SUCCESS";
const SERVICE_OPERATIONALHISTORY_REQUEST = "SERVICE_OPERATIONALHISTORY_REQUEST";
const SERVICE_OPERATIONALHISTORY_SUCCESS = "SERVICE_OPERATIONALHISTORY_SUCCESS";
const SERVICE_OPERATIONALHISTORY_ERROR = "SERVICE_OPERATIONALHISTORY_ERROR";
const SERVICE_LINKSTATUS_REQUEST = "SERVICE_LINKSTATUS_REQUEST";
const SERVICE_LINKSTATUS_ERROR = "SERVICE_LINKSTATUS_ERROR";
const SERVICE_LINKSTATUS_SUCCESS = "SERVICE_LINKSTATUS_SUCCESS";
const SERVICE_UPDATE_REQUEST = "SERVICE_UPDATE_REQUEST";
const SERVICE_UPDATE_ERROR = "SERVICE_UPDATE_ERROR";
const SERVICE_UPDATE_SUCCESS = "SERVICE_UPDATE_SUCCESS";
const SERVICE_CREATE_REQUEST = "SERVICE_CREATE_REQUEST";
const SERVICE_CREATE_ERROR = "SERVICE_CREATE_ERROR";
const SERVICE_CREATE_SUCCESS = "SERVICE_CREATE_SUCCESS";
const SERVICE_HANDOFF_REQUEST = "SERVICE_HANDOFF_REQUEST";
const SERVICE_HANDOFF_SUCCESS = "SERVICE_HANDOFF_SUCCESS";
const SERVICE_HANDOFF_ERROR = "SERVICE_HANDOFF_ERROR";
const SERVICE_DEPROVISION_REQUEST = "SERVICE_DEPROVISION_REQUEST";
const SERVICE_DEPROVISION_SUCCESS = "SERVICE_DEPROVISION_SUCCESS";
const SERVICE_DEPROVISION_ERROR = "SERVICE_DEPROVISION_ERROR";
const SERVICE_DELETE_REQUEST = "SERVICE_DELETE_REQUEST";
const SERVICE_DELETE_SUCCESS = "SERVICE_DELETE_SUCCESS";
const SERVICE_DELETE_ERROR = "SERVICE_DELETE_ERROR";
const VPLS_MACTABLE_REQUEST = "VPLS_MACTABLE_REQUEST";
const VPLS_MACTABLE_SUCCESS = "VPLS_MACTABLE_SUCCESS";
const VPLS_MACTABLE_ERROR = "VPLS_MACTABLE_ERROR"
const SERVICES_THIRD_PARTY_REQUEST = "SERVICES_THIRD_PARTY_REQUEST";
const SERVICES_THIRD_PARTY_SUCCESS = "SERVICES_THIRD_PARTY_SUCCESS";
const SERVICES_THIRD_PARTY_ERROR = "SERVICES_THIRD_PARTY_ERROR";
const SERVICES_THIRD_PARTY_PROVIDER_REQUEST = "SERVICES_THIRD_PARTY_PROVIDER_REQUEST";
const SERVICES_THIRD_PARTY_HEADENDS_REQUEST = "SERVICES_THIRD_PARTY_HEADENDS_REQUEST";
const SERVICES_THIRD_PARTY_CREATE = "SERVICES_THIRD_PARTY_CREATE";
const SERVICES_THIRD_PARTY_DELETE = "SERVICES_THIRD_PARTY_DELETE";
const SERVICES_THIRD_PARTY_TYPES_REQUEST = "SERVICES_THIRD_PARTY_TYPES_REQUEST";
const SERVICES_THIRD_PARTY_SYNC = "SERVICES_THIRD_PARTY_SYNC"
const SERVICE_ENDCHECK_REQUEST = "SERVICE_ENDCHECK_REQUEST"
const SERVICE_LINKS_REQUEST = "SERVICE_LINKS_REQUEST"
const SERVICE_LINKS_SUCCESS = "SERVICE_LINKS_SUCCESS"
const SERVICE_LINKS_ERROR = "SERVICE_LINKS_ERROR"
const SERVICE_LINKS_CREATE = "SERVICE_LINKS_CREATE"
const SERVICE_LINKS_CREATE_SUCCESS = "SERVICE_LINKS_CREATE_SUCCESS"
const SERVICE_LINKS_CREATE_ERROR = "SERVICE_LINKS_CREATE_ERROR"
const SERVICE_LINKS_DELETE = "SERVICE_LINKS_DELETE"
const SERVICE_LINKS_DELETE_SUCCESS = "SERVICE_LINKS_DELETE_SUCCESS"
const SERVICE_LINKS_DELETE_ERROR = "SERVICE_LINKS_DELETE_ERROR"
const SERVICE_PROVISIONING_STATEMENT = "SERVICE_PROVISIONING_STATEMENT"

import Vue from "vue";


const state = {
    status: "", 
    services: null, 
    thirdPartyServices: null,
    serviceLinks: null
};

const getters = {
    getServicesStatus: state => state.status,
    getServicesList: state => (state.services === null ? [] : state.services),
    getAllServices: (state) => {
        return (state.services === null ? [] : state.services)
    },
    getAllThirdPartyServices: (state) => {
        return (state.thirdPartyServices === null ? [] : state.thirdPartyServices)
    },
    getThirdPartyService: (state) => (circuitid) => {
        if(state.thirdPartyServices === null) {return [] }
        return state.thirdPartyServices.find(thisService => thisService.circuitid === circuitid)
    },
    getThirdPartyServiceByServiceid: (state) => (serviceid) => {
        if(state.thirdPartyServices === null) {return {} }
        return state.thirdPartyServices.find(thisService => thisService.serviceid === serviceid)
    },
    getThirdPartyServicesListByHead: (state) => (headendid) => {
        return (state.services === null ? [] : state.services.filter(service => {
            return service.headendid === headendid
        }))
    },
    getThirdPartyServicesListByTail: (state) => (tailendid) => {
        return (state.services === null ? [] : state.services.filter(service => {
            return service.tailendid === tailendid
        }))
    },
    getServiceLinks: (state) => {
        return (state.serviceLinks === null ? [] : state.serviceLinks)
    },
    getServiceLinksBySource: (state)=> (customerid) => {
        if(!state.serviceLinks){
            return []
        }

        return state.serviceLinks.filter(customer => customer.customerid === customerid)
    },
    getService: (state) => (serviceid) => {
        if(state.services === null) {return {} }
        return state.services.find(service => service.serviceid === serviceid.toUpperCase())
    },
    getThirdServiceByServiceID: (state) => (serviceid) => {
        if(state.thirdPartyServices === null) {return {} }
        return state.thirdPartyServices.find(circuit => circuit.serviceid === serviceid)
    },
    isServicesListLoaded: state => !!state.services,
    isThirdPartyServicesLoaded: state => !!state.thirdPartyServices,
    getServicesListByType: (state) => (servicetype) => {
        return (state.services === null ? [] : state.services.filter(service => {
                return service.type === servicetype
            }))
    },
    getServicesListBySite: (state) => siteuuid => {
        let searchTerm = new RegExp(siteuuid, "i")
        return (state.services === null ? [] : state.services.filter((service => searchTerm.test(service.aendsiteid) || searchTerm.test(service.bendsiteid))))
    },
    getServicesListByCustomerID: (state) => customeruuid => {
        return (state.services === null ? [] : state.services.filter((service => service.customerid===customeruuid)))
    },
    searchServices: (state) => searchParam => {
        let searchTerm = new RegExp(searchParam, "i") //Services are searched by Service ID, Handoff A's Name or Site Number, Handoff B's Name or Site Number
        return (state.services === null ? [] : state.services.filter((service => searchTerm.test(service.serviceid) ||searchTerm.test(service.description) || searchTerm.test(service.aendsitenumber) || searchTerm.test(service.aendsitename) || searchTerm.test(service.bendsitenumber) || searchTerm.test(service.bendsitename))))
    },
    searchThirdServices: (state) => searchParam => {
        let searchTerm = new RegExp(searchParam, "i") //Services are searched by Service ID, Handoff A's Name or Site Number, Handoff B's Name or Site Number
        return (state.thirdPartyServices === null ? [] : state.thirdPartyServices.filter((service => searchTerm.test(service.circuitid) || searchTerm.test(service.headendid) || searchTerm.test(service.redundantheadendid) || searchTerm.test(service.tailendid) || searchTerm.test(service.serviceid))))
    },
    getServiceSelectionList:(state)=> { //Standardized getter for services in multiselects
        if (state.services == null) {
            return [];
        }

        var getServices = state.services
        var serviceIDs = []

        for (let i = 0; i < getServices.length; i++) {
            var thisService = {serviceid: '', name: '', linkstatus: {}}
            thisService.serviceid = getServices[i].serviceid
            thisService.name = getServices[i].serviceid + ": " + getServices[i].aendsitename + " to " + getServices[i].bendsitename
            thisService.linkstatus.overallstatus = ''
            serviceIDs.push(thisService)
        }

        return serviceIDs
    },
    getServiceDescription: () =>  (theType, theSpeed) => {
      let serviceDescription = ''

      switch (theType) {
        case 'A':
            serviceDescription = "Unmanaged Fibre"
            break
        case 'B':
            serviceDescription = "Managed " + theSpeed
            break
        case 'C':
            serviceDescription = theSpeed + " Fibre Channel" 
            break
        case 'D':
            serviceDescription = "Managed " + theSpeed
            break
        case 'E':
            serviceDescription = theSpeed + " Layer 2" 
            break
        case 'F':
            serviceDescription = theSpeed + " VPLS Connection"
            break
        case 'G':
            serviceDescription = theSpeed + " Layer 3"
            break
        case 'H':
            serviceDescription = theSpeed + "  Internet Connection"
            break
        case 'Q':
            serviceDescription = "Unmanaged Fibre"
            break
        case 'W':
            serviceDescription = theSpeed + "  Internet Connection"
            break
        case 'Z':
            serviceDescription = "Unmanaged Fibre"
            break
      }

      return serviceDescription
    },

};

const actions = {
    serviceUsageColour(usage){
        if(usage > 95){ //Above usage threshold, return red
            return "danger"
        } else if(usage > 80){ //Above usage threshold, return red
            return "warning"
        } else{ //Normal utilization, return green
            return "success"
        }
    },
    serviceUsageText(usage){
        if(usage > 95){
            return "At Capacity"
        } else if(usage > 80 ){
            return "Nearing Capacity"
        } else{
            return "Available"
        }
    },
    [SERVICES_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(SERVICES_REQUEST);
            commit('addLoading', {handle: 'services', name: 'Load Services'})
            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };

            fetch(Vue.prototype.$apiServer + 'services', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'services')
                        if (resp.result === 'Success') {
                            commit(SERVICES_SUCCESS, resp)
                            resolve(resp)
                        } else {
                            commit(SERVICES_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'services')
                    commit(SERVICES_ERROR);
                    reject(response)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    }                  
                }
            })    
        })
    },
    [SERVICE_LINKS_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_LINKS_REQUEST);
            commit('addLoading', {handle: 'serviceLinks', name: 'Load Service Links'})
            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
            };

            fetch(Vue.prototype.$apiServer + 'service/links', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'serviceLinks')
                        if (resp.result === 'Success') {
                            commit(SERVICE_LINKS_SUCCESS, resp)
                            resolve(resp)
                        } else {
                            commit(SERVICE_LINKS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'serviceLinks')
                    commit(SERVICE_LINKS_ERROR);
                    reject(response)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    }                  
                }
            })    
        })
    },
    [SERVICE_LINKS_DELETE]: ({commit, dispatch}, linkid) => {
    //    window.console.log("Service Update Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SERVICE_LINKS_DELETE);
            commit('addLoading', {handle: 'servicelinkDelete'+linkid, name: 'Deleting Service Link '+linkid})

            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            };
                       
            fetch(Vue.prototype.$apiServer + 'service/link/' + linkid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'servicelinkDelete'+linkid)
                    if (resp.result === 'Success') {
                        commit(SERVICE_LINKS_DELETE_SUCCESS)
                        dispatch(SERVICE_LINKS_REQUEST)
                        resolve(resp)
                    } else {
                        commit(SERVICE_LINKS_DELETE_ERROR)
                        reject(resp)
                    }
                    })
                } else { //Error
                    commit('removeLoading', 'servicelinkDelete'+linkid)
                    commit(SERVICE_LINKS_DELETE_ERROR);
                    reject(response)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    }                  
                }
            })


        })   
    },
    [SERVICES_THIRD_PARTY_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(SERVICES_THIRD_PARTY_REQUEST);
            commit('addLoading', {handle: 'thirdservices', name: 'Load Third-Party Services'})
            
            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };
                       
            fetch(Vue.prototype.$apiServer + 'netbox/thirdparties', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'thirdservices')
                    if (resp.result === 'Success') {
                        commit(SERVICES_THIRD_PARTY_SUCCESS, resp)
                        resolve(resp)
                    } else {
                        commit(SERVICES_THIRD_PARTY_ERROR)
                        reject(resp)
                    }
                    })
                } else { //Error
                    commit('removeLoading', 'thirdservices')
                    commit(SERVICES_ERROR);
                    reject(response)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    }                  
                }
            })
        })   
    },
    [SERVICES_THIRD_PARTY_DELETE]: ({commit, dispatch}, circuitid) => {
    //    window.console.log("Service Update Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SERVICES_THIRD_PARTY_DELETE);
            commit('addLoading', {handle: 'thirdservicedelete'+circuitid, name: 'Deleting Third-Party Service '+circuitid})

            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };
                       
            fetch(Vue.prototype.$apiServer + 'netbox/thirdparty/' + circuitid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'thirdservicedelete'+circuitid)
                    if (resp.result === 'Success') {
                        commit(SERVICE_DELETE_SUCCESS)
                        dispatch(SERVICES_THIRD_PARTY_REQUEST)
                        resolve(resp)
                    } else {
                        commit(SERVICE_DELETE_ERROR)
                        reject(resp)
                    }
                    })
                } else { //Error
                    commit('removeLoading', 'thirdservicedelete'+circuitid)
                    commit(SERVICE_DELETE_ERROR);
                    reject(response)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    }                  
                }
            })


        })   
    },
    [SERVICE_REQUEST]: ({commit, dispatch}, serviceID) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_REQUEST);
            commit('addLoading', {handle: 'service'+serviceID, name: 'Load Service '+serviceID})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };
                       
            fetch(Vue.prototype.$apiServer + 'service/'+serviceID, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'service'+ serviceID)
                        if (resp.result === 'Success') {
                            commit(SERVICE_SUCCESS, {'resp': resp, 'serviceid': serviceID})
                            resolve(resp)
                        } else {
                            commit(SERVICE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'service'+ serviceID)
                    commit(SERVICE_ERROR);
                    reject(response)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    }                  
                }
            })
        })
    },
    [SERVICES_THIRD_PARTY_PROVIDER_REQUEST]: () => {
        return new Promise((resolve, reject) => {
        //    commit('addLoading', {handle: 'service'+serviceID, name: 'Load Service '+serviceID})


        let loginDetails = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //body: JSON.stringify(payload)
            //    body: JSON.stringify({})
        };
                       
        fetch(Vue.prototype.$apiServer + '/netbox/providers', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        if (resp.result === 'Success') {
                             resp.payload = resp.payload.filter(item => item !== "VERNet") //Filter out the VERNet value as it's not used
                            resolve(resp)
                        } else {
                            reject(resp)
                        }
                    })
                } else { //Error
                    response.json().then(err => {
                        reject(err)
                    })              
                }
            })
        })
    },
    [SERVICES_THIRD_PARTY_TYPES_REQUEST]: () => {
        return new Promise((resolve, reject) => {
        //    commit('addLoading', {handle: 'service'+serviceID, name: 'Load Service '+serviceID})


        let loginDetails = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //body: JSON.stringify(payload)
            //    body: JSON.stringify({})
        };

        fetch(Vue.prototype.$apiServer + '/netbox/virtualcircuittypes', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        if (resp.result === 'Success') {
                            resolve(resp)
                        } else {
                            reject(resp)
                        }
                    })
                } else { //Error
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICES_THIRD_PARTY_HEADENDS_REQUEST]: () => {
        return new Promise((resolve, reject) => {
            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };
                        
            fetch(Vue.prototype.$apiServer + '/netbox/headends', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        if (resp.result === 'Success') {
                            resolve(resp)
                        } else {
                            reject(resp)
                        }
                    })
                } else { //Error
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_UTILISATION_REQUEST]: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_UTILISATION_REQUEST);
        //    commit('addLoading', {handle: 'service'+serviceID, name: 'Load Service '+serviceID})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            };
                        

            fetch(Vue.prototype.$apiServer + 'service/'+payload.serviceid+`/utilisation/`+payload.timespan, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        if (resp.result === 'Success') {
                            commit(SERVICE_UTILISATION_SUCCESS, {'resp': resp, 'serviceid': payload.serviceid})
                            resolve(resp)
                        } else {
                            commit(SERVICE_UTILISATION_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SERVICE_UTILISATION_ERROR)
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_HANDOFF_REQUEST]: ({commit, dispatch}, serviceID) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_HANDOFF_REQUEST);
            commit('addLoading', {handle: 'serviceHandoffs' + serviceID, name: 'Identifying Likely Handoffs for ' + serviceID})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };
                       
            fetch(Vue.prototype.$apiServer + 'service/' + serviceID + '/handofffinder', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'serviceHandoffs' + serviceID)
                        if (resp.result === 'Success') {
                            commit(SERVICE_HANDOFF_SUCCESS, {'resp': resp, 'serviceid': serviceID})
                            resolve(resp)
                        } else {
                            commit(SERVICE_HANDOFF_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SERVICE_HANDOFF_ERROR)
                    commit('removeLoading', 'serviceHandoffs' + serviceID)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_DEPROVISION_REQUEST]: ({commit, dispatch}, payload) => {
    //    window.console.log("Service Creation Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SERVICE_DEPROVISION_REQUEST);
            commit('addLoading', {handle: 'servicedeprovision'+ payload.serviceid, name: 'Deprovisioning Service '+ payload.serviceid})

            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/'+ payload.serviceid +'/deprovision', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicedeprovision'+payload.serviceid)
                        if (resp.result === 'Success') {
                            commit(SERVICE_DEPROVISION_SUCCESS, {'resp': resp})
                            resolve(resp)
                        } else {
                            commit(SERVICE_DEPROVISION_ERROR);
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SERVICE_DEPROVISION_ERROR);
                    commit('removeLoading', 'servicedeprovision'+payload.serviceid)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })



        })
    },
    [SERVICES_THIRD_PARTY_CREATE]: ({commit, dispatch}, payload) => {
    //    window.console.log("Service Creation Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SERVICE_CREATE_REQUEST);
            commit('addLoading', {handle: 'thirdservicecreate'+ payload.serviceid, name: 'Create Third-Party Service '+ payload.circuitid})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };
                        
            fetch(Vue.prototype.$apiServer + 'netbox/thirdparty', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'thirdservicecreate'+payload.serviceid)
                        if (resp.result === 'Success') {
                            commit(SERVICE_CREATE_SUCCESS, { 'payload': payload})
                            dispatch(SERVICES_THIRD_PARTY_REQUEST)
                            resolve(resp)
                        } else {
                            commit(SERVICE_CREATE_ERROR);
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SERVICE_CREATE_ERROR);
                    commit('removeLoading', 'thirdservicecreate'+payload.serviceid)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
            
        })
    },
    [SERVICES_THIRD_PARTY_SYNC]: ({commit, dispatch}) => {
    //    window.console.log("Service Creation Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SERVICE_CREATE_REQUEST);
            commit('addLoading', {handle: 'thirdservicesync', name: 'Syncing Third-Party Services'})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        

            fetch(Vue.prototype.$apiServer + 'netbox/thirdparty/sync', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'thirdservicesync')
                        if (resp.result === 'Success') {
                            commit(SERVICES_THIRD_PARTY_REQUEST)
                            resolve(resp)
                        } else {
                            commit(SERVICE_CREATE_ERROR);
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'thirdservicesync')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })

        })
    },
    [SERVICE_CREATE_REQUEST]: ({commit, dispatch}, payload) => {
    //    window.console.log("Service Creation Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SERVICE_CREATE_REQUEST);
            commit('addLoading', {handle: 'servicecreate'+ payload.serviceid, name: 'Create Service '+ payload.serviceid})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'service', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicecreate'+payload.serviceid)
                        if (resp.result === 'Success') {
                            commit(SERVICE_CREATE_SUCCESS, { 'payload': payload})
                            resolve(resp)
                        } else {
                            commit(SERVICE_CREATE_ERROR);
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicecreate'+payload.serviceid)
                    commit(SERVICE_CREATE_ERROR);
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
    })
    },
    [SERVICE_UPDATE_REQUEST]: ({commit, dispatch}, payload) => {
    //    window.console.log("Service Update Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SERVICE_UPDATE_REQUEST);
            commit('addLoading', {handle: 'serviceupdate'+payload.serviceid, name: 'Update Service '+payload.serviceid})

            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/'+payload.serviceid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'serviceupdate'+payload.serviceid)
                        if (resp.result === 'Success') {
                            commit(SERVICE_UPDATE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(SERVICE_UPDATE_ERROR);
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'serviceupdate'+payload.serviceid)
                    commit(SERVICE_UPDATE_ERROR);
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_DELETE_REQUEST]: ({commit, dispatch}, serviceid) => {
        //    window.console.log("Service Update Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SERVICE_DELETE_REQUEST);
            commit('addLoading', {handle: 'servicedelete'+serviceid, name: 'Deleting Service '+serviceid})


            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/'+serviceid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicedelete'+serviceid)
                        if (resp.result === 'Success') {
                            commit(SERVICE_DELETE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(SERVICE_DELETE_ERROR);
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicedelete'+serviceid)
                    commit(SERVICE_DELETE_ERROR);
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })


        })
    },
    [SERVICE_ENDCHECK_REQUEST]: ({commit, dispatch}, serviceID) => {
        return new Promise((resolve, reject) => {
            commit('addLoading', {handle: 'endtest'+serviceID, name: 'Get ' + serviceID + " Path Diagnostics"})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };

            fetch(Vue.prototype.$apiServer + 'service/'+serviceID+'/endtoendcheck', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'endtest'+serviceID)
                        if (resp.result === 'Success') {
                            resolve(resp)
                        } else {
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'endtest'+serviceID)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_MACTABLE_REQUEST]: ({commit, dispatch}, serviceID) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_MACTABLE_REQUEST);
            commit('addLoading', {handle: 'servicemacs'+serviceID, name: 'Load Service '+serviceID+ ' MAC Table'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'tools/mactable/'+serviceID, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicemacs'+serviceID)
                        if (resp.result === 'Success') {
                            commit(SERVICE_MACTABLE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(SERVICE_MACTABLE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicemacs'+serviceID)
                    commit(SERVICE_MACTABLE_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })


        })
    },
    [VPLS_MACTABLE_REQUEST]: ({commit, dispatch}, vplsID) => {
        return new Promise((resolve, reject) => {
            commit(VPLS_MACTABLE_REQUEST);
            commit('addLoading', {handle: 'vplsmacs'+vplsID, name: 'Load VPLS MAC Table'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'tools/mactable/full/'+vplsID, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'vplsmacs'+vplsID)
                        if (resp.result === 'Success') {
                            commit(VPLS_MACTABLE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(VPLS_MACTABLE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'vplsmacs'+vplsID)
                    commit(VPLS_MACTABLE_ERROR);
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_L1_REQUEST]: ({commit, dispatch}, serviceID) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_L1_REQUEST);
            commit('addLoading', {handle: 'servicel1'+serviceID, name: 'Load Service '+serviceID+ ' L1 Diagnostics'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'tools/layer1/'+serviceID, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicel1'+serviceID)
                        if (resp.result === 'Success') {
                            commit(SERVICE_L1_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(SERVICE_L1_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicel1'+serviceID)
                    commit(SERVICE_L1_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })


        })
    },
    [SERVICE_LIGHT_REQUEST]: ({commit, dispatch}, { serviceID }) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_LIGHT_REQUEST);
            commit('addLoading', {handle: 'servicelight'+serviceID, name: 'Load Service '+serviceID+ ' Light Levels'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/'+serviceID + '/lightlevels', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicelight'+serviceID)
                        if (resp.result === 'Success') {
                            commit(SERVICE_LIGHT_SUCCESS)
                            resolve(resp.payload)
                        } else {
                            commit(SERVICE_LIGHT_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicelight'+serviceID)
                    commit(SERVICE_LIGHT_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })


        })
    },
    [SERVICE_TRAFFIC_REQUEST]: ({commit, dispatch}, { serviceID }) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_TRAFFIC_REQUEST);
            commit('addLoading', {handle: 'servicetraffic'+serviceID, name: 'Load Service '+serviceID+ ' ' + 'Traffic Level'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/'+serviceID + '/trafficvalues', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicetraffic'+serviceID)
                        if (resp.result === 'Success') {
                            commit(SERVICE_TRAFFIC_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(SERVICE_TRAFFIC_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicetraffic'+serviceID)
                    commit(SERVICE_TRAFFIC_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_OPERATIONALHISTORY_REQUEST]: ({commit, dispatch}, { serviceID, charttimespan}) => {
    //    window.console.log("Chart Timespan: " + charttimespan)
        return new Promise((resolve, reject) => {
            commit(SERVICE_OPERATIONALHISTORY_REQUEST);
            commit('addLoading', {handle: 'serviceoperationalhistory'+serviceID, name: 'Load Service '+serviceID+ ' Operational History'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/'+serviceID + '/operationalhistory/' + charttimespan, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'serviceoperationalhistory'+serviceID)
                        if (resp.result === 'Success') {
                            commit(SERVICE_OPERATIONALHISTORY_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(SERVICE_OPERATIONALHISTORY_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'serviceoperationalhistory'+serviceID)
                    commit(SERVICE_OPERATIONALHISTORY_ERROR);
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_LIGHTHISTORY_REQUEST]: ({commit, dispatch}, { serviceID, chartType, chartEnd, charttimespan}) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_LIGHTHISTORY_REQUEST);
            commit('addLoading', {handle: 'servicelighthistory'+chartEnd+serviceID, name: 'Load Service '+serviceID+ ' ' + chartEnd + '-end Light History'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/'+serviceID + '/' + chartType + '/' + chartEnd + '/' + charttimespan, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicelighthistory'+chartEnd+serviceID)
                        if (resp.result === 'Success') {
                            commit(SERVICE_LIGHTHISTORY_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(SERVICE_LIGHTHISTORY_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicelighthistory'+chartEnd+serviceID)
                    commit(SERVICE_LIGHTHISTORY_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_TRAFFICHISTORY_REQUEST]: ({commit, dispatch}, { serviceID, charttimespan}) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_TRAFFICHISTORY_REQUEST);
            commit('addLoading', {handle: 'servicetraffichistory'+serviceID, name: 'Load Service '+serviceID+ ' ' + 'Traffic History'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/'+serviceID + '/traffichistory'+ '/' + charttimespan, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicetraffichistory'+serviceID)
                        if (resp.result === 'Success') {
                            commit(SERVICE_TRAFFICHISTORY_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(SERVICE_TRAFFICHISTORY_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicetraffichistory'+serviceID)
                    commit(SERVICE_TRAFFICHISTORY_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_LINKSTATUS_REQUEST]: ({commit, dispatch}, { serviceID }) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_LINKSTATUS_REQUEST);
            commit('addLoading', {handle: 'servicelink'+serviceID, name: 'Load Service '+serviceID+ ' Status'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/'+serviceID + '/linkstatus', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicelink'+serviceID)
                        if (resp.result === 'Success') {
                            commit(SERVICE_LINKSTATUS_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(SERVICE_LINKSTATUS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicelink'+serviceID)
                    commit(SERVICE_LINKSTATUS_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })

        })
    },
    [SERVICE_LINKS_CREATE]: ({commit, dispatch}, payload) => {
    //    window.console.log("Service Creation Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SERVICE_LINKS_CREATE);
            commit('addLoading', {handle: 'servicelinkcreate'+ payload.serviceid, name: 'Create Service '+ payload.serviceid})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/link', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicelinkcreate'+payload.serviceid)
                        if (resp.result === 'Success') {
                            commit(SERVICE_LINKS_CREATE_SUCCESS)
                            dispatch(SERVICE_LINKS_REQUEST)
                            resolve(resp)
                        } else {
                            commit(SERVICE_LINKS_CREATE_ERROR);
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicelinkcreate'+payload.serviceid)
                    commit(SERVICE_LINKS_CREATE_ERROR);
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_LINKS_DELETE]: ({commit, dispatch}, servicelinkid) => {
        //    window.console.log("Service Update Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SERVICE_LINKS_DELETE);
            commit('addLoading', {handle: 'servicelinkdelete'+servicelinkid, name: 'Deleting Service Link'})


            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/link/'+servicelinkid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'servicelinkdelete'+servicelinkid)
                        if (resp.result === 'Success') {
                            commit(SERVICE_LINKS_DELETE_SUCCESS)
                            dispatch(SERVICE_LINKS_REQUEST)
                            resolve(resp)
                        } else {
                            commit(SERVICE_LINKS_DELETE_ERROR);
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'servicelinkdelete'+servicelinkid)
                    commit(SERVICE_LINKS_DELETE_ERROR);
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [SERVICE_PROVISIONING_STATEMENT]: ({commit, dispatch}, serviceid) => {
        return new Promise((resolve, reject) => {
            commit(SERVICE_PROVISIONING_STATEMENT);
            commit('addLoading', {handle: 'provisioningStatement', name: 'Retrieving Provisioning Statement'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'service/' + serviceid + '/provisioningstatement', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.blob().then(resp => {
                        commit(SERVICE_UPDATE_SUCCESS);
                        commit('removeLoading', 'provisioningStatement')
                        const downloadUrl = window.URL.createObjectURL(new Blob([resp]));

                        const link = document.createElement('a');

                        link.href = downloadUrl;

                        link.setAttribute('download', serviceid + ' Provisioning Statement.pdf'); //any other extension

                        document.body.appendChild(link);

                        link.click();
                        link.remove();

                        Vue.prototype.$snotify.success(
                            "File Downloaded",
                            {
                                timeout: 2000,
                                showProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                            }
                        );
                        resolve(resp)
                    })
                } else { //Error
                    commit(SERVICE_UPDATE_ERROR);
                    commit('removeLoading', 'provisioningStatement')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
};

const mutations = {
    [SERVICES_REQUEST]: state => {
        state.status = "loading";
        //Vue.set(state, "services", {});
    },
    [SERVICES_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "services", resp.payload);
    },
    [SERVICES_ERROR]: state => {
        state.status = "error";
    },
    [SERVICE_LINKS_REQUEST]: state => {
        state.status = "loading";
        //Vue.set(state, "services", {});
    },
    [SERVICE_LINKS_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "serviceLinks", resp.payload);
    },
    [SERVICE_LINKS_ERROR]: state => {
        state.status = "error";
    },
    [SERVICE_LINKS_CREATE]: () => {
        state.servicecreatestatus = "loading";
    },
    [SERVICE_LINKS_CREATE_SUCCESS]: () => {
        state.servicecreatestatus = "success";
    },
    [SERVICE_LINKS_CREATE_ERROR]: () => {
        state.servicecreatestatus = "error";
    },
    [SERVICE_LINKS_DELETE]: () => {
        state.servicecreatestatus = "loading";
    },
    [SERVICE_LINKS_DELETE_SUCCESS]: () => {
        state.servicecreatestatus = "success";
    },
    [SERVICE_LINKS_DELETE_ERROR]: () => {
        state.servicecreatestatus = "error";
    },
    [SERVICES_THIRD_PARTY_REQUEST]: state => {
        state.status = "loading";
        //Vue.set(state, "services", {});
    },
    [SERVICES_THIRD_PARTY_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "thirdPartyServices", resp.payload);
    },
    [SERVICES_THIRD_PARTY_ERROR]: state => {
        state.status = "error";
    },
    [SERVICE_REQUEST]: () => {
        state.servicestatus = "loading";
    },
    [SERVICE_SUCCESS]: () => {
        state.servicestatus = "success";
    },
    [SERVICE_ERROR]: () => {
        state.servicestatus = "error";
    },
    [SERVICE_CREATE_REQUEST]: () => {
        state.servicecreatestatus = "loading";
    },
    [SERVICE_CREATE_SUCCESS]: () => {
        state.servicecreatestatus = "success";
    },
    [SERVICE_CREATE_ERROR]: () => {
        state.servicecreatestatus = "error";
    },
    [SERVICE_DELETE_REQUEST]: () => {
        state.servicedeletestatus = "loading";
    },
    [SERVICE_DELETE_SUCCESS]: () => {
        state.servicedeletestatus = "success";
    },
    [SERVICE_DELETE_ERROR]: () => {
        state.servicedeletestatus = "error";
    },
    [SERVICE_MACTABLE_REQUEST]: () => {
        state.servicemacstatus = "loading";
    },
    [SERVICE_MACTABLE_SUCCESS]: () => {
        state.servicemacstatus = "success";
    },
    [SERVICE_MACTABLE_ERROR]: () => {
        state.servicemacstatus = "error";
    },
    [VPLS_MACTABLE_REQUEST]: () => {
        state.vplsmacstatus = "loading";
    },
    [VPLS_MACTABLE_SUCCESS]: () => {
        state.vplsmacstatus = "success";
    },
    [VPLS_MACTABLE_ERROR]: () => {
        state.vplsmacstatus = "error";
    },
    [SERVICE_L1_REQUEST]: () => {
        state.servicel1status = "loading";
    },
    [SERVICE_L1_SUCCESS]: () => {
        state.servicel1status = "success";
    },
    [SERVICE_L1_ERROR]: () => {
        state.servicel1status = "error";
    },
    [SERVICE_LIGHT_REQUEST]: () => {
        state.servicelightstatus = "loading";
    },
    [SERVICE_LIGHT_SUCCESS]: () => {
        state.servicelightstatus = "success";
    },
    [SERVICE_LIGHT_ERROR]: () => {
        state.servicelightstatus = "error";
    },
    [SERVICE_UTILISATION_REQUEST]: () => {
        state.serviceutilisationstatus = "loading";
    },
    [SERVICE_UTILISATION_SUCCESS]: () => {
        state.serviceutilisationstatus = "success";
    },
    [SERVICE_UTILISATION_ERROR]: () => {
        state.serviceutilisationstatus = "error";
    },
    [SERVICE_TRAFFIC_REQUEST]: () => {
        state.servicetrafficstatus = "loading";
    },
    [SERVICE_TRAFFIC_SUCCESS]: () => {
        state.servicetrafficstatus = "success";
    },
    [SERVICE_TRAFFIC_ERROR]: () => {
        state.servicetrafficstatus = "error";
    },
    [SERVICE_LIGHTHISTORY_REQUEST]: () => {
        state.servicelighthistorystatus = "loading";
    },
    [SERVICE_LIGHTHISTORY_SUCCESS]: () => {
        state.servicelighthistorystatus = "success";
    },
    [SERVICE_LIGHTHISTORY_ERROR]: () => {
        state.servicelighthistorystatus = "error";
    },
    [SERVICE_OPERATIONALHISTORY_REQUEST]: () => {
        state.serviceoperationalhistorystatus = "loading";
    },
    [SERVICE_OPERATIONALHISTORY_SUCCESS]: () => {
        state.serviceoperationalhistorystatus = "success";
    },
    [SERVICE_OPERATIONALHISTORY_ERROR]: () => {
        state.serviceoperationalhistorystatus = "error";
    },
    [SERVICE_HANDOFF_REQUEST]: () => {
        state.servicehandoffstatus = "loading";
    },
    [SERVICE_HANDOFF_SUCCESS]: () => {
        state.servicehandoffstatus = "success";
    },
    [SERVICE_HANDOFF_ERROR]: () => {
        state.servicehandoffstatus = "error";
    },
    [SERVICE_TRAFFICHISTORY_REQUEST]: () => {
        state.servicetraffichistorystatus = "loading";
    },
    [SERVICE_TRAFFICHISTORY_SUCCESS]: () => {
        state.servicetraffichistorystatus = "success";
    },
    [SERVICE_TRAFFICHISTORY_ERROR]: () => {
        state.servicetraffichistorystatus = "error";
    },
    [SERVICE_LINKSTATUS_REQUEST]: () => {
        state.servicelinkstatus = "loading";
    },
    [SERVICE_LINKSTATUS_SUCCESS]: () => {
        state.servicelinkstatus = "success";
    },
    [SERVICE_LINKSTATUS_ERROR]: () => {
        state.servicelinkstatus = "error";
    },
    [SERVICE_UPDATE_REQUEST]: () => {
        state.updatestatus = "loading";
    },
    [SERVICE_UPDATE_SUCCESS]: () => {
        state.updatestatus = "success";
    },
    [SERVICE_UPDATE_ERROR]: () => {
        state.updatestatus = "error";
    },
    [SERVICE_DEPROVISION_REQUEST]: () => {
        state.deprovstatus = "loading";
    },
    [SERVICE_DEPROVISION_SUCCESS]: () => {
        state.deprovstatus = "success";
    },
    [SERVICE_DEPROVISION_ERROR]: () => {
        state.deprovstatus = "error";
    },
    [SERVICE_PROVISIONING_STATEMENT]: () => {
        state.deprovstatus = "loading";
    },
    [SERVICE_DEPROVISION_SUCCESS]: () => {
        state.deprovstatus = "success";
    },
    [SERVICE_DEPROVISION_ERROR]: () => {
        state.deprovstatus = "error";
    },
    [AUTHTOKEN_LOGOUT]: state => {
        state.services = null;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};